import React from 'react';
import SignupComponent from '../../Auth/signup';

export default function Signup() {
  return <SignupComponent />;
}
